import type { ReceiveResponse } from '@/types/Models/ReceiveResponse'
import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class ItemsProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'items'

  validate(itemId: string) {
    return this.submit('post', `${this.endpoint}/${itemId}/validate`)
  }

  receive(itemId: string) {
    return this.submit<ReceiveResponse>('put', `${this.endpoint}/${itemId}/receive`)
  }

  optimizationPath(itemId: string) {
    return this.submit('get', `/${this.endpoint}/${itemId}/optimization-path`)
  }

  getHistory(itemId: string) {
    return this.submit('get', `/${this.endpoint}/${itemId}/history`)
  }

  getIntegrationLogs(itemId: string) {
    return this.submit('get', `/${this.endpoint}/${itemId}/integration-logs`)
  }

  recreateLabel(itemId: string) {
    return this.submit('post', `/${this.endpoint}/${itemId}/recreate-labels`)
  }
}
